import { useContext, useEffect } from "react"
import { Field } from "formik"
import { FormContext } from "../../context/formContext"
import { UserContext } from "../../context/userContext"
import { InputText as Input } from "primereact/inputtext"
import fieldVisibility from "../../helpers/fieldVisibility"
import { TRIM_TYPES, trimTextValue } from "./helpers/trimTextValue"
import styles from "../../styles/Form.module.css"
import useParticipantEmailChecker from "../../hooks/useParticipantEmailChecker"

const EMAIL_NOT_UNIQUE_MSG =
  'Email is already in use. Please provide an alternative email or select "No" for valid email address to continue.'

export default function TypeParticipantEmail({
  field,
  block,
  index,
  typeForm,
}) {
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  const { checkParticipantEmail } = useParticipantEmailChecker()

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  const isRequired = checkIfRequired()

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field
          name={field.field_name}
          validate={async (value) => {
            if (!value) return undefined
            const isUnique = await checkParticipantEmail({
              email: value,
              participant_id: userCtx.current_participant_id || "",
              organization_id: userCtx.session.user.organization_id,
              current_participant_id: userCtx.current_participant_id || "",
              typeForm,
            })
            return isUnique ? undefined : EMAIL_NOT_UNIQUE_MSG
          }}
        >
          {({ field: formikField, meta, form: formik }) => (
            <span className="p-input-icon-right">
              {formik.isValidating && <i className="pi pi-spin pi-spinner" />}
              <Input
                name={formikField.name}
                value={formikField.value}
                onChange={(e) => {
                  formik.setFieldValue(
                    formikField.name,
                    trimTextValue(e, TRIM_TYPES.BOTH).target.value,
                    false,
                  )
                }}
                disabled={isDisabled}
                onBlur={() => {
                  formik.setFieldTouched(formikField.name, true, true)
                }}
                autoComplete="off"
              />
              {meta.touched && meta.error && !formik.isValidating && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </span>
          )}
        </Field>
      </div>
    </div>
  )
}
